import type React from "react";
import styles from "./ThresholdLegend.module.scss";
export type LegendItem = {
  color: string;
  label: string;
};

export type ThresholdLegendProps = {
  items: LegendItem[];
};

export const ThresholdLegend: React.FC<ThresholdLegendProps> = ({ items }) => {
  return (
    <div className={styles.container}>
      {items.map((item, index) => (
        <div key={`${item.color}_${item.label}_${index}`} className={styles.legendItem}>
          <div className={styles.circle} style={{ backgroundColor: item.color }} />
          <span className={styles.label}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};
